import api from '../../utils/api'

interface TFBOResponse {
    ok: boolean
    results: any[]
    error?: string
}

interface ApiResponse<T> {
    ok: boolean
    result: T | null
    error?: string
}

export const stripNulls = <T extends Record<string, any>>(obj: T): T =>
    Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== null)) as T

export const executeTFBO = async (payloads: any[]): Promise<TFBOResponse> => {
    try {
        const sanitized = payloads.map(p => p.parameters ? { ...p, parameters: stripNulls(p.parameters) } : p)
        const response = await api.multilpeTFBO(sanitized)
        // _tfbo already handles NOT_AUTHORIZED + refreshOnce internally

        const ok = response.payload.every((item: any) => item.status === 'OK')
        const results = response.payload.map((item: any) => item.result)
        if (!ok) {
            const failedItem = response.payload.find((item: any) => item.status !== 'OK')
            return { ok: false, results, error: failedItem?.result?.message || failedItem?.status || 'Request failed' }
        }
        return { ok, results }
    } catch (error) {
        console.error(error)
        return { ok: false, results: [], error: error instanceof Error ? error.message : String(error) }
    }
}

export const executeApi = async <T = any>(apiCall: () => Promise<any>): Promise<ApiResponse<T>> => {
    try {
        const response = await apiCall()
        // _tfbo / _auth already handle NOT_AUTHORIZED + refreshOnce internally
        const status = response.payload?.[0]?.status

        if (status === 'OK') {
            return { ok: true, result: response.payload[0].result }
        }
        return { ok: false, result: null, error: response.payload?.[0]?.result?.message || status || 'Request failed' }
    } catch (error) {
        console.error(error)
        return { ok: false, result: null, error: error instanceof Error ? error.message : String(error) }
    }
}
